import { render } from "./LbrxMicroEffect.vue?vue&type=template&id=a4ca6290&scoped=true"
import script from "./LbrxMicroEffect.vue?vue&type=script&lang=js"
export * from "./LbrxMicroEffect.vue?vue&type=script&lang=js"

import "./LbrxMicroEffect.vue?vue&type=style&index=0&id=a4ca6290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ca6290"]])

export default __exports__